import config from "../../config";
import $axios from "@/plugins/axios";

const url = `${config.baseUrl}search`;

export class SearchService {
    searchAll (text, page, size) {
        return $axios.post(`${url}/${page}/${size}`, {search: text}).then(res => res.data);
    }
}

